var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('v-dialog',{staticStyle:{"z-index":"999999"}}),_c('notifications',{attrs:{"group":"vera"}}),_c('loading-overlay',{directives:[{name:"show",rawName:"v-show",value:(_vm.requestCounter > 0),expression:"requestCounter > 0"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }